module.exports = __webpack_public_path__ + "img/angle-left-solid.2e9bc263.svg";